/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_Connection_ErrorInputs */

const en_read_along_ai_connection_error = /** @type {(inputs: Read_Along_Ai_Connection_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connection interrupted. Try again to resume this generation.`)
};

const es_read_along_ai_connection_error = /** @type {(inputs: Read_Along_Ai_Connection_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se interrumpió la conexión. Inténtalo de nuevo para reanudar esta generación.`)
};

/**
* | output |
* | --- |
* | "Connection interrupted. Try again to resume this generation." |
*
* @param {Read_Along_Ai_Connection_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_connection_error = /** @type {((inputs?: Read_Along_Ai_Connection_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_Connection_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_connection_error(inputs)
	return en_read_along_ai_connection_error(inputs)
});